export type MobileMenuVariant = 'classic' | 'modern'

/** Templates opt in; all other shops keep their existing navigation. */
export const resolveMobileMenuVariant = (value: unknown): MobileMenuVariant => (
  value === 'modern' ? 'modern' : 'classic'
)
